import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle2, Download } from 'lucide-react';

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div className="absolute inset-0 bg-gradient-to-br from-brand-50 via-background to-gold-400/10"></div>

      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-brand-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gold-500 rounded-full blur-3xl"></div>
      </div>

      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10"
      >
        <div className="max-w-4xl mx-auto text-center">
          <motion.div variants={item} className="inline-block mb-4 px-4 py-2 bg-brand-100 text-brand-700 rounded-full text-sm font-semibold">
            IPL Launched! <span className="ml-2 inline-block animate-bounce">🚀</span>
          </motion.div>

          <motion.h1 variants={item} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 leading-tight">
            Kelola IPL Perumahan Anda
            <span className="block text-brand-700">
              Lebih Mudah & Efisien
            </span>
          </motion.h1>

          <motion.p variants={item} className="text-lg sm:text-xl text-foreground/70 mb-8 max-w-2xl mx-auto">
            Platform digital terlengkap untuk mengelola Iuran Pemeliharaan Lingkungan.
            Otomatisasi pembayaran, notifikasi real-time, dan laporan keuangan dalam satu sistem.
          </motion.p>

          <motion.div variants={item} className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              onClick={() => scrollToSection('demo')}
              size="lg"
              className="bg-brand-700 hover:bg-brand-800 text-white px-8 py-6 text-lg group"
            >
              Coba Demo Gratis
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
            </Button>
            <Button
              onClick={() => scrollToSection('pricing')}
              size="lg"
              variant="outline"
              className="border-2 border-brand-700 text-brand-700 hover:bg-brand-50 px-8 py-6 text-lg"
            >
              Lihat Harga
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="border-2 border-gold-500 text-gold-600 hover:bg-gold-50 px-8 py-6 text-lg group"
            >
              <Link to="/download">
                <Download className="mr-2 group-hover:translate-y-0.5 transition-transform" size={20} />
                Download APK
              </Link>
            </Button>
          </motion.div>

          <motion.div variants={item} className="flex flex-wrap justify-center gap-6 text-sm text-foreground/70">
            <div className="flex items-center gap-2">
              <CheckCircle2 className="text-brand-600" size={20} />
              <span>Setup dalam 1-2 Minggu</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="text-brand-600" size={20} />
              <span>Support 24/7</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle2 className="text-brand-600" size={20} />
              <span>Data Aman & Terenkripsi</span>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};
